var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"py-md-3 text-center",attrs:{"min-height":"3em","color":_vm.colorBkgd}},[_c('span',{staticClass:"fs-1_2 primary--text"},[_c('b',[_vm._v(_vm._s(_vm.title)+" ")]),_vm._v(" "+_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }